// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","menu":"Header_menu__Zy7KP","current":"Header_current__1ho3e","counter":"Header_counter__2_zj_"};